import { useAnalyticSession } from "@octopusdeploy/portal-analytics";
import type { ArgoCDRegistrationPageFields } from "~/analytics/AnalyticSession";
import type { ArgoCDRegistrationPageAnalyticsDispatcher, ArgoCDRegistrationPageEvent } from "~/analytics/Analytics";
export function useArgoCDRegistrationPageAnalyticsDispatcher(): ArgoCDRegistrationPageAnalyticsDispatcher {
    const session = useAnalyticSession();
    return (name: string, event: ArgoCDRegistrationPageEvent) => {
        const fields: ArgoCDRegistrationPageFields = {
            "Gateway Name": session.anonymize(`${event.gatewayName}`),
            "Space Id": session.anonymize(`${event.spaceId}`),
            "Unique Identifier": session.anonymize(`${event.spaceId}-${event.gatewayName}`),
            "Gateway Name Populated": event.gatewayNamePopulated,
            "Environments Count": event.environmentsCount,
            "Web Interface URL Populated": event.webInterfaceUrlPopulated,
            "Argo CD Service DNS Populated": event.argoCDServiceDnsPopulated,
            "Argo CD Auth Token Populated": event.argoCDAuthTokenPopulated,
            "Argo CD Instance Uses Self Signed Certificate": event.argoCDInstanceUsesSelfSignedCertificate,
            "Octopus Server URL Populated": event.octopusServerUrlPopulated,
            "Octopus Server gRPC URL Populated": event.octopusServerGrpcUrlPopulated,
            "Validation Errors": event.validationErrors,
        };
        session.track(name, fields);
    };
}
